
const About = () => {
    return ( 
        <> 
            <h2 className=" display-4 text-center"> Im a <span className="links">Developer.</span> </h2>
                    <p className="text-center mt-5">
                        Im student at ITLA <br/>
                        I'm constantly learming about programming especially the client side
                        <br/>
                        I love React.js
                    </p>
                  
                    <div >
                            <p className="text-center">
                                If you want to see my CV  <br/> <a className="btn button text_b d-lg-none d-md-none d-sm-none" target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1STAvLVy6HY0V-oHeJqlC34X9jnnO0Vq0/view">Click Here!</a>
                            </p>
                        </div>
                  <div className=" d-none d-sm-block">
                    <div id="wrapper">
                            <a  className="my-super-cool-btn" target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1STAvLVy6HY0V-oHeJqlC34X9jnnO0Vq0/view">
                                <div className="dots-container">
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                                </div>
                                <span>Click  Here!</span>
                            </a>
                            </div>
                  </div>
                  <br/>
                    
        </>
     );
}
 
export default About;